import { useIntl } from "react-intl";

import { InvitationRead } from "@nens/rana/api-v1";
import { FormErrors } from "@nens/ranalib";

import { InvitationFormValues, validateAccountForm } from "../utils/validate-account-form";

/** Maps validation error keys to their default (English) messages for react-intl. */
const DEFAULT_MESSAGES: Record<string, string> = {
  "error.validation.no_given_name": "Please enter a given name.",
  "error.validation.no_family_name": "Please enter a family name.",
  "error.validation.no_username": "Please enter a username.",
  "error.validation.no_valid_username": "Username contains invalid characters.",
  "error.validation.username_too_short": "Username must be at least 4 characters long.",
  "error.validation.username_too_long": "Username must be at most 128 characters long.",
  "error.validation.no_password": "Please enter a password.",
  "error.validation.passwords_different": "The two passwords do not match.",
  "error.validation.password_too_short": "Password needs to be a minimum of 8 characters.",
  "error.validation.password_too_long": "Password can be a maximum of 99 characters.",
  "error.validation.password_upper_lower_digit":
    "Password needs to contain at least one uppercase, one lowercase, and one digit.",
  "error.validation.password_space": "Password can't lead or end with a space",
};

export function useCreateNewAccountForm(invitation: InvitationRead) {
  const intl = useIntl();

  const initialValues: InvitationFormValues = {
    email: invitation.email,
    given_name: "",
    family_name: "",
    username: invitation.email,
    password: "",
    password_again: "",
  };

  const validateForm = (values: InvitationFormValues): FormErrors => {
    const validationErrors = validateAccountForm(values);
    const errors: FormErrors = {};

    for (const [field, errorKey] of Object.entries(validationErrors)) {
      errors[field] = intl.formatMessage({
        id: errorKey,
        defaultMessage: DEFAULT_MESSAGES[errorKey] ?? errorKey,
      });
    }

    return errors;
  };

  return {
    initialValues,
    validateForm,
  };
}
